import { ContentCard } from 'apps/dashboard/shared/scripts/components';
import { PlanType } from 'apps/shared/scripts/__generated__/graphql.generated';
import { useCardById } from 'apps/shared/scripts/graphql';

import LoadingWidget from './LoadingWidget';
import WidgetBody from './WidgetBody';
import WidgetFooter from './WidgetFooter';
import WidgetHeader from './WidgetHeader';
import WidgetStats from './WidgetStats';

interface Props {
  id: string;
}

const CardWidget = ({ id }: Props) => {
  const { card, isLoading } = useCardById({ variables: { id } });
  const isPro = card?.plan === PlanType.Pro;

  if (isLoading || !card) {
    return <LoadingWidget />;
  }

  return (
    <ContentCard noBorder>
      <WidgetHeader isPro={isPro} />
      <WidgetBody headline={card.headline} recipientName={card.recipientName} />
      <WidgetStats createdAt={card.createdAt} postCount={card.postCount} />
      <WidgetFooter id={card.id} />
    </ContentCard>
  );
};

CardWidget.displayName = 'CardWidget';

export default CardWidget;
